import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import ModalContainer from '../ModalContainer';

// Actions
import {
  hideModal,
} from '../../../actions/modal';

class OnboardingSuccessModal extends Component {

  render() {
    return (
      <ModalContainer
        modalExit={true}
        optionalClasses="onboarding-success"
      >
        <header>
          <h2>
            Success!
          </h2>
          <h3>
            You now are signed up for a Locker Linked account.
          </h3>
          <p>
            Thanks for joining. Our mission is to provide you with first-rate recruitment network services and tools to prepare you for upcoming college athletic opportunities. It's time to start customizing your player profile!
          </p>
          <div className="video-player">
            <iframe
              src="https://player.vimeo.com/video/306424613"
              width="640"
              height="360"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen="true"
              title="Locker Linked Welcome Video"
            >
            </iframe>
          </div>
        </header>
        <a onClick={() => this.props.hideModal()} className="cta invert full-width">
          Get Started
        </a>
      </ModalContainer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    },
  }
}

export default connect(
  null,
  mapDispatchToProps
)(OnboardingSuccessModal)



// WEBPACK FOOTER //
// ./src/components/Modals/Onboarding/OnboardingSuccessModal.js